module.exports = __webpack_public_path__ + "img/fond-pour-EC-tuto-72dpi.95379aec.png";